<div class="pdf-container">
	<iframe
		:src="pdfUrl"
		class="pdf-frame"
	>
	</iframe>
</div>

